export const STATUS_REQUEST_CHANGE_CERT = {
    1: {
      label: "Chờ duyệt",
      class: "orange"
    },
    2: {
      label: "Nghiệp vụ từ chối",
      class: "red"
    },
    3: {
      label: "Nghiệp vụ đã duyệt",
      class: "geekblue"
    },
    4: {
      label: "Hoàn thành",
      class: "green"
    }
  };

  export const FILE_TYPE_OPTIONS = {
    1: "Ký điện tử",
    2: "Ký tươi"
  };